import { render, staticRenderFns } from "./inactiveMembers.vue?vue&type=template&id=0bd81284&scoped=true&"
import script from "./inactiveMembers.vue?vue&type=script&lang=js&"
export * from "./inactiveMembers.vue?vue&type=script&lang=js&"
import style0 from "./inactiveMembers.vue?vue&type=style&index=0&id=0bd81284&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd81284",
  null
  
)

export default component.exports